// extracted by mini-css-extract-plugin
export default {"layout":"_0aYKV0G1--ThreePartLayout_layout__wnh8B","main":"_0aYKV0G1--ThreePartLayout_main__baV46"};